import { Service } from "@roc/feature-app-core";

export abstract class ValuationReviewReportBaseService extends Service {

  abstract getValuationReviewInformationByLoanIdAndPropertyId(loanId: number, propertyId: number);
  abstract getPropertyActivityByPropertyId(propertyId: number);
  abstract downloadAppraisalReport(propertyId: number)
  abstract getLiquidityDocument(propertyId: number, loanId: number);
  abstract saveValuationDetails(data: any);
}